module.exports = __webpack_public_path__ + "fonts/CiscoSansTTRegular.woff2";